import { FilterGroupsTable } from '../components/FilterGroupsTable';

export const RequestAccess = ({ isMobile, model }) => {
  return <FilterGroupsTable isMobile={isMobile} model={model} />;
};
